import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CaseSearch } from '../beans/CaseSearch';
import { urlLinks } from '../utility/url-links';
import { CaseService } from './case.service';
import { HttpService } from './http.service';

@Injectable()
export class ReportService {

	constructor(private http: HttpService, private caseService: CaseService) { }

	private normalizeSearch(search: CaseSearch): CaseSearch {
		return {
			...search,
			id: this.normalizeId(search.id),
			dataPTP: this.caseService.toBackendIsoDate(search.dataPTP),
			data_suzd_inst_grdelo_ot: this.caseService.toBackendIsoDate(search.data_suzd_inst_grdelo_ot),
			data_suzd_inst_grdelo_do: this.caseService.toBackendIsoDate(search.data_suzd_inst_grdelo_do)
		};
	}

	/** Sync с CaseService.normalizeId — иначе '#3331' минава като string и
	 *  Jackson или връща 400, или го интерпретира като 'без филтър' → всички дела. */
	private normalizeId(value: any): number | null {
		if (value === null || value === undefined || value === '') {
			return null;
		}
		const cleaned = String(value).replace(/[^0-9]/g, '');
		return cleaned ? Number(cleaned) : null;
	}

	executeXLSReport(search: CaseSearch): Observable<HttpResponse<Blob>> {
		return this.http.postBlob(
			urlLinks.rest.report.executeReport,
			this.normalizeSearch(search)
		);
	}

	executeXLSReportTrauma(search: CaseSearch): Observable<HttpResponse<Blob>> {
		return this.http.postBlob(
			urlLinks.rest.report.executeReportTrauma,
			this.normalizeSearch(search)
		);
	}

	executeNasrocheniXLSReport(isExtended: boolean): Observable<HttpResponse<Blob>> {
		const url = `${urlLinks.rest.report.executeNasrocheniReport}?isExtended=${isExtended}`;
		console.log('[ReportService] executeNasrocheniXLSReport:', url);

		// тук нямаш реално тяло, но POST изисква body → даваме null
		return this.http.postBlob(url, null);
	}

	executeCalendarXLSReport(year: number, month: number, isExtended: boolean): Observable<HttpResponse<Blob>> {
		const url = `${urlLinks.rest.report.executeCalendarReport}?year=${year}&month=${month}&isExtended=${isExtended}`;
		return this.http.postBlob(url, null);
	}

	executeNewCasesReport(from: string, to: string): Observable<HttpResponse<Blob>> {
		const url = `${urlLinks.rest.report.executeNewCasesReport}?from=${from}&to=${to}`;
		return this.http.postBlob(url, null);
	}

	executeLawyerWorkloadReport(from: string): Observable<HttpResponse<Blob>> {
		const url = `${urlLinks.rest.report.executeLawyerWorkloadReport}?from=${from}`;
		return this.http.postBlob(url, null);
	}
}
